import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=fba9f814&scoped=true&"
import script from "./DownloadCenter.vue?vue&type=script&lang=js&"
export * from "./DownloadCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba9f814",
  null
  
)

export default component.exports